import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";
import { tagsService } from "@/services/tagsService";
import type { Tag } from "@shared/schema";

const TAGS_STALE_MS = 60_000;

/** Fetch user tags from Supabase (not HTTP /api/tags). */
export function useTags() {
  const { user } = useAuth();
  return useQuery<Tag[]>({
    queryKey: ["/api/tags", user?.id],
    queryFn: async () => {
      if (!user) return [];
      return await tagsService.getTags();
    },
    enabled: !!user,
    staleTime: TAGS_STALE_MS,
  });
}

export function tagsQueryKey(userId: string | undefined) {
  return ["/api/tags", userId] as const;
}
